import { defineStore } from 'pinia';
import { LocalStorage } from 'quasar';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: (() => {
      const u = LocalStorage.getItem('hubmasterscuser');
      if (u && u.chatbotVisible === undefined) u.chatbotVisible = true;
      return u || null;
    })()
  }),
  getters: {
    get: (state) => state.user,
  },
  actions: {
    set(val) {
      LocalStorage.set('hubmasterscuser', val)
      this.user = val
    },
    logout() {
      this.user = null;
      LocalStorage.removeItem('hubmasterscuser');
    },

    updateChatbotVisibility(visible) {
      this.user.chatbotVisible = visible;
      this.set(this.user);
    },

    isRoleAdmin(){
      return ['ROLE_ADMIN'].includes(this.user.rol);
    },
    isRoleSuperAdmin(){
      return ['ROLE_SUPERADMIN'].includes(this.user.rol);
    },
    isRoleEngineering(){
      return ['ROLE_ENGINEERING'].includes(this.user.rol);
    },
    isRoleUser(){
      return ['ROLE_USER'].includes(this.user.rol);
    },
    isRoleSuperAdminOrEngineering(){
      return this.isRoleSuperAdmin() || this.isRoleEngineering();
    },
    isRoleAdminOrSuperAdmin(){
      return this.isRoleAdmin() || this.isRoleSuperAdmin();
    },
  }
});
